<template>
  <v-row no-gutters v-if="system_notice" class="system-notice-bar">
    <v-col cols="auto" class="system-notice-icon" style="">
      <v-img :src="pinImage"></v-img>
    </v-col>
    <v-col class="system-notice-text"> {{ system_notice[language] }} </v-col>
  </v-row>
</template>

<script setup>
import pinImage from '@/assets/images/Pin.svg'

import { computed } from 'vue'

import { useStore } from 'vuex'
const store = useStore()

const language = computed(() => {
  const langCode = store.state.i18n.language
  if (langCode === 'zhHant-HK') return 'zhHant'
  else return langCode
})

const system_notice = computed(() => store.state.interface.general.system_notice)
</script>

<style scoped>
.system-notice-bar {
  min-height: 3rem;
  width: 100dvw;
  position: absolute;
  top: 0;
  z-index: 1;
  background: rgba(222, 226, 232, 0.9);
  align-content: center;
  padding: 0 1rem;
}

.system-notice-icon {
  width: 1.25rem;
  margin-right: 0.75rem;
}

.system-notice-text {
  color: #282828;
  font-family: Inter !important;
  font-size: 14px;
  font-weight: 400;
}
</style>
